define.alias("shared/components/shared/media/filter/filter-media-type", "settings/components/shared/media/filter/filter-media-type");